import { Logo, NavLinks } from "./index.js";
import { Box, Flex, Spacer, useMediaQuery } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import Hamburger from "./Hamburger.js";

const Header = () => {
  const [isLargerThan1300] = useMediaQuery("(min-width: 1300px)");
  return (
    <Flex
      bg="headline.400"
      p={4}
      align="center"
      padding={"25px 40px"}
      gap={"25px"}
    >
      <Link to="/" style={{ textDecoration: "none" }}>
        <Box p="2">
          <Logo
            image={"apple-touch-icon.png"}
            size={{ base: "60px", md: "80px" }}
            color="white"
          />
        </Box>
      </Link>
      <Spacer />
      {isLargerThan1300 ? (
        <NavLinks
          direction="row"
          active="white"
          notActive={"#f2f2f2"}
          signInColor="#f2f2f2"
        />
      ) : (
        <Hamburger />
      )}
    </Flex>
  );
};
export default Header;
